import React from 'react'
import {
  Row,
  Col,
  Button,
} from 'react-bootstrap'
import { connect } from 'react-redux'
import { getCommissionWidgetDataAction } from './../../actions/DashboardActions'

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'


class CommissionWidget extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      monthly : {
        totalSalesCm : 0,
        grossSalesCm : 0,
        newSaleCm : 0
      },
      ytd : {
        totalSalesCm : 0,
        grossSalesCm : 0,
        newSaleCm : 0
      },
      quarterly : {
        totalSalesCm : 0,
        grossSalesCm : 0,
        newSaleCm : 0
      },
      isMonthly : false,
      isQuarterly : false,
      isYtd : true,
      showLoader : false,
      zillowCnt : 0,
      wordofmouthCnt : 0,
      referralCnt : 0
    }
    
  }


  componentWillMount(){
   /** call api for commission and calculation */
    this.props.getCommissionWidgetDataAction().then(res => {
      
      let totalSalesCmForMonth = 0;
      let grossSalesCmForMonth = 0;
      let newSaleCmForMonth = 0;

      let totalSalesCmForYTD = 0;
      let grossSalesCmForYTD = 0;
      let newSaleCmForYTD = 0;

      let totalSalesCmForQua = 0;
      let grossSalesCmForQua = 0;
      let newSaleCmForQua = 0;

      let zillowCnt = 0;
      let wordofmouthCnt = 0;
      let referralCnt = 0;

      if(!res.error) {        
          let currentMonthCommission = res.currentMonthCommission;      
          let yearToDateCommission = res.yearToDateCommission;
          let quarterCommission = res.quarterCommission;

          //current month commission - summation of all attributes from api with key currentMonthCommission
          for(let i=0;i<currentMonthCommission.length;i++) {
            let c = currentMonthCommission[i];
            //Total Sales Commission - total of agreedOpenPrice
            if(c.agreedOpenPrice !== undefined && c.agreedOpenPrice !== null && c.agreedOpenPrice !== "") {
              totalSalesCmForMonth = totalSalesCmForMonth + c.agreedOpenPrice
            }
            //Gross Sales Commission - total of Percentage
            if(c.Percentage !== undefined && c.Percentage !== null && c.Percentage !== "") {
              grossSalesCmForMonth = grossSalesCmForMonth + c.Percentage
            }
            //NET Sales Commission - total of totalFees
            if(c.totalFees !== undefined && c.totalFees !== null && c.totalFees !== "") {
              newSaleCmForMonth = newSaleCmForMonth + c.totalFees
            }        
          }

          //year to date commission - summation of all attributes from api with key yearToDateCommission
          for(let i=0;i<yearToDateCommission.length;i++) {
            let c = yearToDateCommission[i];
             //Total Sales Commission - total of agreedOpenPrice
            if(c.agreedOpenPrice !== undefined && c.agreedOpenPrice !== null && c.agreedOpenPrice !== "") {
              totalSalesCmForYTD = totalSalesCmForYTD + c.agreedOpenPrice
            }
            //Gross Sales Commission - total of Percentage
            if(c.Percentage !== undefined && c.Percentage !== null && c.Percentage !== "") {
              grossSalesCmForYTD = grossSalesCmForYTD + c.Percentage
            }
             //NET Sales Commission - total of totalFees
            if(c.totalFees !== undefined && c.totalFees !== null && c.totalFees !== "") {
              newSaleCmForYTD = newSaleCmForYTD + c.totalFees
            }        
          }

          //year to date commission - summation of all attributes from api with key quarterCommission
          for(let i=0;i<quarterCommission.length;i++) {
            let c = quarterCommission[i];
             //Total Sales Commission - total of agreedOpenPrice
            if(c.agreedOpenPrice !== undefined && c.agreedOpenPrice !== null && c.agreedOpenPrice !== "") {
              totalSalesCmForQua = totalSalesCmForQua + c.agreedOpenPrice
            }
            //Gross Sales Commission - total of Percentage
            if(c.Percentage !== undefined && c.Percentage !== null && c.Percentage !== "") {
              grossSalesCmForQua = grossSalesCmForQua + c.Percentage
            }
             //NET Sales Commission - total of totalFees
            if(c.totalFees !== undefined && c.totalFees !== null && c.totalFees !== "") {
              newSaleCmForQua = newSaleCmForQua + c.totalFees
            }        
          }

          //get lead sorce details
          if(res.leadSourceData !== undefined && res.leadSourceData !== null) {

            if(res.leadSourceData.Zillow !== undefined && res.leadSourceData.Zillow !== null) {
              zillowCnt = res.leadSourceData.Zillow;        
            }
            if(res.leadSourceData['Word of mouth'] !== undefined && res.leadSourceData['Word of mouth'] !== null) {
              wordofmouthCnt = res.leadSourceData['Word of mouth'];        
            }
            if(res.leadSourceData.Referral !== undefined && res.leadSourceData.Referral !== null) {
              referralCnt = res.leadSourceData.Referral
            }
          } 

      }


      let monthly = {
        totalSalesCm : totalSalesCmForMonth,
        grossSalesCm : grossSalesCmForMonth,
        newSaleCm : newSaleCmForMonth
      }
      let ytd = {
        totalSalesCm : totalSalesCmForYTD,
        grossSalesCm : grossSalesCmForYTD,
        newSaleCm : newSaleCmForYTD
      }
      let quarterly = {
        totalSalesCm : totalSalesCmForQua,
        grossSalesCm : grossSalesCmForQua,
        newSaleCm : newSaleCmForQua
      }

      this.setState({
        monthly : monthly,
        ytd : ytd,
        quarterly : quarterly,
        zillowCnt : zillowCnt,
        wordofmouthCnt : wordofmouthCnt,
        referralCnt : referralCnt
      });
      
    }).catch(err => {
      /*if api fails then no need to update state*/
    });
  }

  /**
   * @desc formate price in to minion with M
   * @param {*} x 
   */
  valueFormat (x) {

      if(isNaN(x)) return x;

      if(x > 0) {
          return (x/1000000).toFixed(2) + "M";
      }
      else {
        return "0 M"
      }
  }


  render() {
   
    let showTotalSalesCommission = this.state.monthly.totalSalesCm;
    let showGrossCommission = this.state.monthly.grossSalesCm;
    let showNetSaleCommission = this.state.monthly.grossSalesCm - this.state.monthly.newSaleCm;

    if(this.state.isMonthly) {
      showTotalSalesCommission = this.state.monthly.totalSalesCm;
      showGrossCommission = this.state.monthly.grossSalesCm;
      showNetSaleCommission = this.state.monthly.grossSalesCm - this.state.monthly.newSaleCm;
    }

    if(this.state.isQuarterly) {
      showTotalSalesCommission = this.state.quarterly.totalSalesCm;
      showGrossCommission = this.state.quarterly.grossSalesCm;
      showNetSaleCommission = this.state.quarterly.grossSalesCm - this.state.quarterly.newSaleCm; 
    }

    if(this.state.isYtd) {
      showTotalSalesCommission = this.state.ytd.totalSalesCm;
      showGrossCommission = this.state.ytd.grossSalesCm;
      showNetSaleCommission = this.state.ytd.grossSalesCm - this.state.ytd.newSaleCm;
    }

    let zillowCnt = this.state.zillowCnt
    let wordofmouthCnt = this.state.wordofmouthCnt
    let referralCnt = this.state.referralCnt

    let optionsPieProduction = {
      chart: {
        type: 'pie',
        options3d: {
          enabled: true,
          alpha: 0
        },
        width: '250',
        height: '200'
      },
      colors: ['#0098e9', '#ff5900', '#737373'],
      title: {
        text: ''
      },
      plotOptions: {
        pie: {
          innerSize: 90,
          depth: 150,
          size: '100%',
          borderColor: 'transparent'
        },
        series: {         
          dataLabels: {
            enabled: false
          },        
        }
      },
      series: [
        {
          data: [
            ['Zillow', zillowCnt], 
            ['Word of mouth', wordofmouthCnt], 
            ['Referral', referralCnt],
          ]
        }
      ],
      tooltip: {
        formatter: function () {
          return '<b>' + this.key + ' : ' + this.y + '</b>'
        }
      }
    }
    
    if(zillowCnt > 0 && zillowCnt < 10) {
      zillowCnt = "0" + zillowCnt
    }

    if(wordofmouthCnt > 0 && wordofmouthCnt < 10) {
      wordofmouthCnt = "0" + wordofmouthCnt
    }

    if(referralCnt > 0 && referralCnt < 10) {
      referralCnt = "0" + referralCnt
    }
    

    return (
      <React.Fragment>
       <div className="dash-col-head with-border">
                <Row className="align-items-center">
                  <Col>
                    <h4 className="color-blue-3 font-16 font-600 mb-0">Production</h4>
                  </Col>
                  <Col align="right" className="col-auto">
                    <div className="switch-btns" style={{opacity: '1'}}>
                      <Button variant="primary" className={this.state.isYtd ? "active" : ""} onClick={()=>{ this.setState({isYtd : true,isQuarterly:false,isMonthly:false}) }} >YTD</Button>
                      <Button variant="primary" className={this.state.isQuarterly ? "active" : ""} onClick={()=>{ this.setState({isYtd : false,isQuarterly:true,isMonthly:false}) }} >Quarterly</Button>
                      <Button variant="primary" className={this.state.isMonthly ? "active" : ""} onClick={()=>{ this.setState({isYtd : false,isQuarterly:false,isMonthly:true}) }} >Monthly</Button>
                    </div>
                  </Col>
                </Row>
              </div>
              <Row>
                <Col xs="12">
                  <div className="production-count high-pie-count">
                    <div className="production-count-inner text-center">
                      <div className="d-blue">
                        <h4>${this.valueFormat(showTotalSalesCommission)}</h4>
                        <p>Total Sales Commission</p>
                      </div>
                      <div className="blue">
                        <h4>${this.valueFormat(showGrossCommission)}</h4>
                        <p>Gross Sales Commission</p>
                      </div>
                      <div className="green">
                        <h4>${this.valueFormat(showNetSaleCommission)}</h4>
                        <p>NET Sales Commission</p>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col xs="12">
                  <div className="high-pie-production">
                    <hr />
                    <HighchartsReact highcharts={Highcharts} options={optionsPieProduction} />
                    <div className="high-pie-count-row">
                      <div className="high-pie-count text-center">
                        <h4>{zillowCnt}</h4>
                        <p>Zillow</p>
                      </div>
                      <div className="high-pie-count text-center">
                        <h4>{wordofmouthCnt}</h4>
                        <p>Word of Mouth</p>
                      </div>
                      <div className="high-pie-count text-center">
                        <h4>{referralCnt}</h4>
                        <p>Referral</p>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    commissionData : state.reducer.commissionData,
  };
};


export default connect(mapStateToProps, { getCommissionWidgetDataAction })(CommissionWidget)